<template>
  <div>
    <div>
      <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>报警管理</el-breadcrumb-item>
        <el-breadcrumb-item>报警设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
      <div>
        <h2>设置报警内容</h2>
      </div>
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="140px">
        <el-form-item label="报警内容" prop="AlarmContent">
          <el-input v-model="addForm.AlarmContent" style="width: 50%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="监控变量" :required="true">
          <el-select v-model="VariableList.ID" placeholder="请设置变量">
            <el-option v-for="(_, p) in VariableList" :key="p" :label="p" :value="p">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="触发报警类型" :required="true">
          <!-- <el-input v-model="addForm.AlarmType" style="width: 50%" size="medium"></el-input> -->
          <el-select v-model="addForm.AlarmType" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="addForm.AlarmType === '0' || addForm.AlarmType === '1'|| addForm.AlarmType === '2' || addForm.AlarmType === '3' || addForm.AlarmType === '4'">
          <el-form-item label="X值" prop="X_Value" required>
            <el-input v-model="addForm.X_Value" style="width: 50%" size="medium"></el-input>
          </el-form-item>
        </div>
        <div v-if="addForm.AlarmType === '2' || addForm.AlarmType === '3'  ">
          <el-form-item label="Y值" prop="Y_Value" required>
          <el-input v-model="addForm.Y_Value" style="width: 50%" size="medium"></el-input>
        </el-form-item>
        </div>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="addForm.Remark" style="width: 50%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <el-button size="medium" type="primary" @click="addAlarmSet()">保存</el-button>
      <el-button size="medium" @click="reSet('addFormRef')">重置</el-button>
    </el-card>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: 1,
                limit: 10,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            // 添加报警设置的表单数据
            addForm: {
                Variable_Maintenance_ID: '',
                AlarmContent: '',
                AlarmType: '',
                X_Value: '',
                Y_Value: '',
                Remark: '',
                CreateTime: '',
            },
            // 变量维护表数据
            VariableList: [],
            //添加表单的验证规则对象
            addFormRules: {
                Variable_Maintenance_ID: [
                    { required: true, message: '请输入报警对象', trigger: 'blur' }
                ],
                AlarmContent: [
                    { required: true, message: '请输入报警内容', trigger: 'blur' },
                ],
            },
            // 触发报警类型
            options: [{
                value: '0',
                label: '大于X值'
            }, {
                value: '1',
                label: '小于X值'
            }, {
                value: '2',
                label: '大于X值且小于Y值'
            }, {
                value: '3',
                label: '大于Y值且小于X值'
            }, {
                value: '4',
                label: '等于X值'
            }],
            value: ''
        }
    },
    created () {
        this.getVariableList()
    },
    methods: {
        // 调用接口新增报警设置
        addAlarmSet () {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("Variable_Maintenance_ID", this.VariableList.ID)
                params.append("AlarmContent", this.addForm.AlarmContent)
                params.append("AlarmType", this.addForm.AlarmType)
                params.append("X_Value", this.addForm.X_Value)
                params.append("Y_Value", this.addForm.Y_Value)
                params.append("Remark", this.addForm.Remark)
                // 可以发起添加用户的网络请求
                // console.log('1111' + params)
                const { data: res } = await this.$http.post('/WMS/InsertMainAlarm', params)
                // console.log('1234' + res)
                this.$message.success('添加报警设置成功！')
            })
        },
        reSet (addFormRef) {
            this.$refs[addFormRef].resetFields();
        },
        // 调用接口获取变量维护表数据
        async getVariableList () {
          const { data: res } = await this.$http.get('/WMS/alertNum')
          // console.log(res.data)
          this.VariableList = res.data || {}
        },
    }
}
</script>

<style>
</style>
